export default __webpack_public_path__ + "static/media/loading.123e2ad4.svg";